/**
 * Created by Ray on 2016/12/26.
 */
import {Component} from '@angular/core';
import {Response} from '@angular/http';
import {Router} from '@angular/router';
import {Message} from 'primeng/primeng';
import {Constants} from '../shared/constants';
import {AuthService} from '../shared/service/auth.service';
import {ProgressService} from '../shared/service/progress.service';
import {MsgService} from "../shared/service/message.service";

@Component({
    selector: 'profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.css']
})
export class ProfileComponent {
    showChangePWD: boolean = false;
    oldPWD;
    newPWD;
    newPWDD;

    constructor(private authService:AuthService) {}

    showChangePanel(){
        this.showChangePWD = true;
        this.oldPWD = null;
        this.newPWD = null;
        this.newPWDD = null;
    }

    changePWD(){
        this.authService.changePWD(this.newPWD);
    }


}



// WEBPACK FOOTER //
// C:/Projects/ServiceChain/servicechain2/svc-ui/TRUNK/src/app/profile/profile.component.ts